import { jsx, jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { useThemeColors } from "@brandclub/bc-widgets";
import { Actions, Action } from "../../../ai-elements/actions.js";
import { CopyIcon } from "../../../icons/CopyIcon.js";
const USER_BUBBLE_BG = "#f6f8fa";
const ACTION_ROW_MIN_HEIGHT = 24;
const VoiceTranscriptBubble = ({ line }) => {
  const { themeColors } = useThemeColors();
  const textColor = themeColors.textPrimary || "#111827";
  const [copied, setCopied] = useState(false);
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(line.text);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
    }
  };
  if (line.role === "user") {
    return /* @__PURE__ */ jsx(
      "div",
      {
        style: {
          display: "flex",
          justifyContent: "flex-end",
          width: "100%",
          marginBottom: 8
        },
        children: /* @__PURE__ */ jsx(
          "div",
          {
            style: {
              maxWidth: "90%",
              background: USER_BUBBLE_BG,
              color: textColor,
              padding: "10px 14px",
              borderRadius: 18,
              // Match the text-surface message bubble (MessageBubbleWidget
              // defaults: 16px / 1.5) so there's no size jump on handoff.
              fontSize: 16,
              lineHeight: 1.5,
              wordBreak: "break-word",
              whiteSpace: "pre-wrap",
              opacity: line.partial ? 0.85 : 1
            },
            children: line.text
          }
        )
      }
    );
  }
  return /* @__PURE__ */ jsxs(
    "div",
    {
      style: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        width: "100%",
        marginBottom: 12
      },
      children: [
        /* @__PURE__ */ jsx(
          "div",
          {
            style: {
              maxWidth: "100%",
              color: textColor,
              fontSize: 16,
              lineHeight: 1.5,
              wordBreak: "break-word",
              whiteSpace: "pre-wrap",
              opacity: line.partial ? 0.85 : 1
            },
            children: line.text
          }
        ),
        /* @__PURE__ */ jsx(Actions, { className: "tw:mt-2", style: { minHeight: ACTION_ROW_MIN_HEIGHT }, children: !line.partial && /* @__PURE__ */ jsx(
          Action,
          {
            label: "Copy",
            tooltip: copied ? "Copied!" : "Copy",
            tooltipOpen: copied || void 0,
            onClick: handleCopy,
            children: /* @__PURE__ */ jsx(CopyIcon, { width: 20, height: 20 })
          }
        ) })
      ]
    }
  );
};
export {
  VoiceTranscriptBubble
};
//# sourceMappingURL=VoiceTranscriptBubble.js.map
